export const DEFAULT_TIMEZONE: string = 'DEFAULT'
